export default "__VITE_ASSET__15Ou8uR9__"